// @flow

import React, { Component } from 'react'
import Recaptcha from 'react-recaptcha'
import { connect } from 'react-redux'
import { Button, Form, Icon, Modal } from 'semantic-ui-react'
import { silver } from 'constants/inlineStyles'

import { getActiveFlyer } from '../../../selectors'
import ModalContainer from './ModalContainer'

let styles = {}

type ReduxStateProps = {|
  senderEmail: string,
  flyerTitle: string
|}

type Props = {|
  ...ReduxStateProps
|}

type State = {|
  messageToSend: string,
  userEmailAddress: string,
  isUserHuman: boolean
|}

// TODO (quinkinser) WIP, this is on hold until email engine is launched
class EmailProgramProviderModal extends Component<Props, State> {
  state = {
    messageToSend: '',
    userEmailAddress: '',
    isUserHuman: false
  }

  handleMessageChange = (e, { value }) => {
    this.setState({ messageToSend: value })
  }

  handleEmailChange = (e, { value }) => {
    this.setState({ userEmailAddress: value })
  }

  handleSubmit = () => {}

  render() {
    // const { flyerTitle, senderEmail } = this.props
    const { messageToSend, isUserHuman, userEmailAddress } = this.state
    const isValidEmail = userEmailAddress.length > 0
    const isMessageReady = messageToSend.length > 0
    const isSubmitEnabled = isUserHuman && isMessageReady && isValidEmail
    return (
      <ModalContainer header="Email Organization">
        <Modal.Content style={styles.contentWrapper}>
          <Form style={styles.form}>
            <Form.TextArea
              label="Message"
              onChange={this.handleMessageChange}
            />
            <Form.Input
              label="Your Email Address"
              placeholder="you@pj.com"
              onChange={this.handleEmailChange}
            />
          </Form>
          <div style={styles.recaptcha}>
            <Recaptcha
              sitekey="6LeLg08UAAAAAC3PtYDt9sjhkD41qrQ0qpGB5tS9"
              render="explicit"
              verifyCallback={() => this.setState({ isUserHuman: true })}
              onloadCallback={() => {}}
            />
          </div>
        </Modal.Content>
        <Modal.Actions style={styles.actions}>
          <Button disabled={!isSubmitEnabled} color="orange" onClick={() => {}}>
            <Icon name="lock" /> Send
          </Button>
        </Modal.Actions>
      </ModalContainer>
    )
  }
}

const mapStateToProps = (state): ReduxStateProps => {
  const flyer = getActiveFlyer(state)
  return {
    senderEmail: flyer.seller_email,
    flyerTitle: flyer.title
  }
}

styles = {
  largeSilverBorder: { border: `4px solid ${silver}` },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'space-around',
    alignItems: 'center'
  },
  recaptcha: {
    marginTop: '16px',
    alignItems: 'center',
    justifyContent: 'space-around'
  },
  form: {
    width: '302px'
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  modalWidth: {
    width: '400px'
  }
}

export default connect(mapStateToProps)(EmailProgramProviderModal)



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/ModalManager/components/EmailProgramProviderModal.js